export default function () {
    const entityDancer = useEntityDancer();

    async function get(filter) {
        let dancers = null,
            error = null,
            hasMore = false;
        try {
            const {data} = await useApi('videos').get('dancers', filter);
            dancers = data.dancers.map((dancer) => {
                return entityDancer.build(dancer);
            });
            hasMore = dancers.length === filter?.paginate?.limit;
        } catch (e) {
            error = useApiError(e);
        }
        return {dancers, error, hasMore};
    }

    return {get};
}
